export const GridRowGap = 8;
export const GridColumnGap = 64;
export const MaxItemWidth = 336;
export const MaxItemHeight = 48;
export const CHANGE_POSITION_TIMEOUT = 4000;
